module.exports = __webpack_public_path__ + "defaultImage-9f28ec84.png";